import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAccordion } from './accordion.interface';
import { foldDownUpAnimation } from '../../../shared/animations/fold.downUp.animation';

@Component({
    selector: 'mlp-ng-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [foldDownUpAnimation]
})
export class AccordionComponent {
    @Input() items: Array<IAccordion>;
}
